import axios from "axios";

let url: string | undefined;

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  url = process.env.REACT_APP_STAGING_URL;
} else {
  url = process.env.REACT_APP_LIVE_URL;
}

export const instance = axios.create({
  baseURL: url,
  // timeout: 1000,
});

instance.interceptors.request.use(
  function (config: any) {
    const token: string = localStorage.getItem("authToken") ?? "";
    console.log(token, "ll");

    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
